import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';


import { AngularFireAuthGuard } from '@angular/fire/auth-guard';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireStorageModule } from '@angular/fire/storage';
// Use to swap apps
import { environment } from '../environments/edmerson/environment.prod';
import { AngularFireDatabase } from '@angular/fire/database';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { PagesComponent } from './components/pages/pages.component';
import { CustomStylesDirective } from './directives/custom-styles.directive';
import { PrimaryColorDirective } from './directives/primary-color.directive';
import { PageThemeDirective } from './directives/theme/page-theme.directive';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';

import { VgCoreModule} from 'videogular2/compiled/core';
import { VgControlsModule} from 'videogular2/compiled/controls';
import { VgOverlayPlayModule} from 'videogular2/compiled/overlay-play';
import { VgBufferingModule} from 'videogular2/compiled/buffering';
import { MediaPlayerComponent } from './media-player/media-player.component';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ChannelsComponent } from './channels/channels.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ChannelPropertiesDirective } from './directives/channel-properties.directive';
import { LiveBroadcastComponent } from './live-broadcast/live-broadcast.component';
import { DashboardButtonThemeDirective } from './directives/dashboard-button-theme.directive';
import { RegisterUserComponent } from './register-user/register-user.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DashboardTilesDirective } from './directives/theme/dashboard-tiles.directive';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';
import { ReviewMessagesComponent } from './review-messages/review-messages.component';
import { EventComponent } from './event/event.component';
import { SideMenuDirective } from './directives/side-menu.directive';
import { MainStylesDirective } from './directives/main-styles.directive';
import { PageStylesDirective } from './directives/page-styles.directive';
import { TitleBarDirective } from './directives/title-bar.directive';
import { LogoDirective } from './directives/logo.directive';
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { ShelformbuilderModule } from '@sheldonmedia/shelformbuilder';
import { DashTileDirectiveDirective } from './directives/dash-tile-directive.directive';
import { FormsDirective } from './directives/forms.directive';
import { ModalPageModule } from './modals/modal/modal.module';
import { Zoom } from '@ionic-native/zoom/ngx';
import { SubscriptionPlansComponent } from './subscription-plans/subscription-plans.component';
import { NetworkInfoComponent } from './components/network-info/network-info.component';
import { ChatComponent } from './components/chat/chat.component';
import { MediaDirective } from './directives/media.directive';
import { ProgramDetailsComponent } from './components/program-details/program-details.component';
import { CardFormComponent } from './stripe/card-form/card-form.component';
import '@stripe/stripe-js';
import { ElementsComponent } from './stripe/elements/elements.component';
import { AngularFireFunctions, AngularFireFunctionsModule } from '@angular/fire/functions';
import { NewsHomeComponent } from './news/news-home/news-home.component';
import { PlayerComponent } from './player/player.component';
import { TilesDirective } from './directives/tiles.directive';
import { EcommerceComponent } from './ecommerce/ecommerce.component';

@NgModule({
  declarations: [
    AppComponent,
    UserProfileComponent,
    PagesComponent,
    CustomStylesDirective,
    PrimaryColorDirective,
    PageThemeDirective,
    MediaPlayerComponent,
    NewsHomeComponent,
    ChannelsComponent,
    DashboardComponent,
    ChannelPropertiesDirective,
    LiveBroadcastComponent,
    DashboardButtonThemeDirective,
    RegisterUserComponent,
    DashboardTilesDirective,
    SignInComponent,
    SignUpComponent,
    ForgotPasswordComponent,
    VerifyEmailComponent,
    ReviewMessagesComponent,
    EventComponent,
    SideMenuDirective,
    MainStylesDirective,
    PageStylesDirective,
    TitleBarDirective,
    LogoDirective,
    DashTileDirectiveDirective,
    FormsDirective,
    SubscriptionPlansComponent,
    NetworkInfoComponent,
    ChatComponent,
    MediaDirective,
    ProgramDetailsComponent,
    CardFormComponent,
    ElementsComponent,
    PlayerComponent,
    TilesDirective,
    EcommerceComponent
  ],
  entryComponents: [
    NetworkInfoComponent,
    ProgramDetailsComponent
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFireFunctionsModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    HttpModule,
    BrowserAnimationsModule,
    MatGridListModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FontAwesomeModule,
    ShelformbuilderModule,
    ModalPageModule
  ],
  exports: [
    ChatComponent
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    AngularFireAuthGuard,
    AngularFireDatabase,
    InAppBrowser,
    Zoom
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}